import {
  YodleeAccountTypes,
  genericIconsByYodleeAccountType,
} from '@constants/yodlee';

type AccountType = keyof typeof YodleeAccountTypes;

export const getGenericIconForAccountType = (accountType: AccountType) =>
  genericIconsByYodleeAccountType[accountType] ||
  genericIconsByYodleeAccountType[YodleeAccountTypes.BANK];
